"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { CreateWaveOutcomeConfig } from "@/types/waves.types";
import { CreateWaveOutcomeType } from "@/types/waves.types";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function CreateWaveOutcomesCICApprove(t0) {
  const $ = _c(32);
  const {
    onOutcome,
    onCancel
  } = t0;
  const outcomeType = CreateWaveOutcomeType.NIC;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: outcomeType,
      title: null,
      credit: null,
      category: null,
      winnersConfig: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [outcome, setOutcome] = useState(t1);
  const [creditError, setCreditError] = useState(false);
  let t2;
  if ($[1] !== outcome) {
    t2 = e => {
      const newCredit = parseFloat(e.target.value);
      const isValid = !isNaN(newCredit) && newCredit >= 0;
      setOutcome({
        ...outcome,
        credit: isValid ? newCredit : null
      });
      setCreditError(false);
    };
    $[1] = outcome;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setCredit = t2;
  let t3;
  if ($[3] !== onOutcome || $[4] !== outcome) {
    t3 = () => {
      const dontHaveCreditSet = !outcome.credit;
      setCreditError(dontHaveCreditSet);
      if (dontHaveCreditSet) {
        return;
      }
      onOutcome(outcome);
    };
    $[3] = onOutcome;
    $[4] = outcome;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onSubmit = t3;
  let t4;
  if ($[6] !== outcome.credit) {
    t4 = outcome.credit !== null ? outcome.credit.toString() : "";
    $[6] = outcome.credit;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `${creditError ? "tw-caret-error tw-ring-error focus:tw-border-error focus:tw-ring-error" : "tw-caret-primary-400 tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400"} ${outcome.credit ? "tw-text-primary-400 focus:tw-text-white" : "tw-text-white"} tw-peer tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-border-iron-600 tw-bg-iron-900 tw-px-4 tw-pb-4 tw-pt-3 tw-text-base tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset sm:tw-text-sm`;
  let t6;
  if ($[8] !== setCredit || $[9] !== t4 || $[10] !== t5) {
    t6 = <input type="text" value={t4} onChange={setCredit} id="outcome-cic-credit" autoComplete="off" className={t5} placeholder=" " />;
    $[8] = setCredit;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = `${creditError ? "peer-focus:tw-text-error" : "peer-focus:tw-text-primary-400"} tw-absolute tw-start-1 tw-top-2 tw-z-10 tw-origin-[0] -tw-translate-y-4 tw-scale-75 tw-transform tw-cursor-text tw-bg-iron-900 tw-px-2 tw-text-base tw-font-normal tw-text-iron-500 tw-duration-300 peer-placeholder-shown:tw-top-1/2 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-scale-100 peer-focus:tw-top-2 peer-focus:-tw-translate-y-4 peer-focus:tw-scale-75 peer-focus:tw-bg-iron-900 peer-focus:tw-px-2 rtl:peer-focus:tw-left-auto rtl:peer-focus:tw-translate-x-1/4`;
  let t8;
  if ($[12] !== t7) {
    t8 = <label htmlFor="outcome-cic-credit" className={t7}>NIC</label>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div className="tw-group tw-relative tw-w-full">{t6}{t8}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== creditError) {
    t10 = creditError && <div className="tw-flex tw-items-center tw-gap-x-2 tw-pt-1.5"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-text-xs tw-font-medium tw-text-error">NIC must be a positive number</div></div>;
    $[17] = creditError;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="tw-grid tw-gap-x-5 tw-pt-[0.5px]"><div>{t9}{t10}</div></div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== onCancel) {
    t12 = <button onClick={onCancel} type="button" className="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-800 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-border-iron-700 hover:tw-bg-iron-700">Cancel</button>;
    $[22] = onCancel;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== onSubmit) {
    t13 = <PrimaryButton onClicked={onSubmit} disabled={false} loading={false} padding="tw-px-4 tw-py-3">Save</PrimaryButton>;
    $[24] = onSubmit;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13) {
    t14 = <div className="tw-flex tw-justify-end tw-gap-x-3">{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t11 || $[30] !== t14) {
    t15 = <div className="tw-flex tw-flex-col tw-gap-y-6">{t11}{t14}</div>;
    $[29] = t11;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}